/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.1.4 Woman_03_Walking.glb --transform
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export default function People3(props) {
  const { nodes, materials } = useGLTF('/Woman_03_Walking-transformed.glb')
  return (
    <group {...props} dispose={null}>
      <group scale={0.01}>
        <mesh geometry={nodes.Body002.geometry} material={materials['Bodymat.003']} rotation={[Math.PI / 2, 0, 0]} />
        <mesh geometry={nodes.Bottoms002.geometry} material={materials['Bottommat.003']} rotation={[Math.PI / 2, 0, 0]} />
        <mesh geometry={nodes.Eyes002.geometry} material={materials['Bodymat.003']} rotation={[Math.PI / 2, 0, 0]} />
        <mesh geometry={nodes.Hair002.geometry} material={materials['Hairmat.003']} rotation={[Math.PI / 2, 0, 0]} />
        <mesh geometry={nodes.Shoes002.geometry} material={materials['Shoesmat.003']} rotation={[Math.PI / 2, 0, 0]} />
        <mesh geometry={nodes.Tops002.geometry} material={materials['Topmat.003']} rotation={[Math.PI / 2, 0, 0]} />
      </group>
    </group>
  )
}

useGLTF.preload('/Woman_03_Walking-transformed.glb')
